import styled from 'styled-components';

import { HalfCircularProgressBar } from '@sorare/core/src/atoms/loader/CircularProgressIndicator/HalfCircularProgressBar';
import type { WidgetChipState } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { WidgetCallout } from '@sorare/core/src/atoms/ui/WidgetCallout/index.tsx';
import { Orb } from '@sorare/core/src/components/Orb';
import type { Unit } from '@sorare/core/src/lib/style.ts';

import { IconWrapper } from '#src/components/series/SeriesMissions/ui.tsx';

import calloutUrl from './assets/callout.webp';
import icon from './assets/icon.svg';

const Img = styled.img`
  object-fit: contain;
`;

type Props = {
  chipState?: WidgetChipState;
  to: string;
  size?: Unit;
  showCallout?: boolean;
  onClick?: () => void;
};

export const DumbPlayMissionWidget = ({
  chipState,
  to,
  size = 5,
  showCallout,
  onClick,
}: Props) => (
  <WidgetCallout
    artworkUrl={showCallout ? calloutUrl : null}
    size={size}
    unfurlTowards="left"
  >
    <Orb
      color="var(--c-arena-primary)"
      size={size}
      chipState={chipState}
      to={to}
      onClick={onClick}
    >
      <HalfCircularProgressBar
        size={size}
        progresses={[1]}
        colors={[
          {
            from: 'var(--c-arena-primary)',
            to: 'var(--c-arena-primary)',
          },
        ]}
        backgroundColor="var(--c-arena-tertiary)"
      />
      <IconWrapper>
        <Img
          src={icon}
          alt=""
          style={{
            width: `calc(${size} * var(--unit) - var(--double-unit))`,
            height: `calc(${size} * var(--unit) - var(--double-unit))`,
          }}
        />
      </IconWrapper>
    </Orb>
  </WidgetCallout>
);
